module.exports = __webpack_public_path__ + "static/media/CountermovementJumpFemale.ae1e6b81.svg";